import React, { Component } from 'react'
import PropTypes from 'prop-types'
import KeyTakeaway from '../../../components/business/creport/keyTakeaway'
import ReportFiles from '../../../components/business/creport/files'

class RangeOfMotionPreview extends Component {
  static propTypes = {
    report: PropTypes.object,
    dealHtml: PropTypes.func
  }

  render() {
    const { report, dealHtml } = this.props
    return (
      <div className="report-physical report-section">
        <h1 className="section-title">5. RANGE OF MOTION</h1>
        <p
          className="text-section"
          dangerouslySetInnerHTML={{
            __html: dealHtml(report.range_of_motion_intro)
          }}
        />
        <h3 className="section-sub-title">Summary</h3>
        <p
          className="text-section"
          dangerouslySetInnerHTML={{
            __html: dealHtml(report.range_of_motion_summary)
          }}
        />
        {/* tests placeholder */}
        <h3 className="section-sub-title">Key Takeaway</h3>
        {report.physical_takeaway && (
          <KeyTakeaway initialValue={report.range_of_motion_takeaway} />
        )}
        {(report.range_of_motion_media_files ||
          report.range_of_motion_media_intro) && (
          <ReportFiles
            readOnly={true}
            files={report.range_of_motion_media_files || []}
            introduction={report.range_of_motion_media_intro}
          />
        )}
      </div>
    )
  }
}

export default RangeOfMotionPreview
